import ImageWithText from './ImageWithText';
import Parallax from '../global/Parallax';

export default class CollectionHeader extends ImageWithText {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */
  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.parallax = new Parallax(this.theme, this.element);
  }
}
